import React, { useState } from 'react';
import { Container, Box, Typography, TextField, Button, Alert } from '@mui/material';
import { api } from '../services/api';
import { useTranslation } from 'react-i18next';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(t('forgot-password.error.generic'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ 
        marginTop: { xs: 10, sm: 12 }, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        minHeight: 'calc(100vh - 120px)',
        py: 4,
      }}>
        <Typography component="h1" variant="h5">{t('forgot-password.title')}</Typography>
        {submitted ? (
          <Alert severity="success" sx={{ mt: 2, width: '100%' }}>
            {t('forgot-password.success.message')}
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={t('email_address')}
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              inputProps={{ dir: i18n.language === 'he' ? 'rtl' : 'ltr' }}
              InputLabelProps={{ 
                style: { 
                  direction: i18n.language === 'he' ? 'rtl' : 'ltr', 
                  textAlign: i18n.language === 'he' ? 'right' : 'left' 
                } 
              }}
              FormHelperTextProps={{ 
                style: { 
                  direction: i18n.language === 'he' ? 'rtl' : 'ltr', 
                  textAlign: i18n.language === 'he' ? 'right' : 'left' 
                } 
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? t('forgot-password.sending') : t('forgot-password.send_reset_link')}
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default ForgotPassword; 